import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import Icon from '../../components/Icon'
import { useStudentsStore } from '../../../stores/studentsStore'
import StudentGoalsTab from './StudentGoalsTab'

const StudentGoalsPage: React.FC = () => {
  const { studentId, id } = useParams<{ studentId?: string; id?: string }>()
  const paramId = studentId || id
  const navigate = useNavigate()
  const { students, loading, fetchStudents } = useStudentsStore()

  console.log('===students', students)

  const currentStudent = students.find((s) => s._id === paramId)

  useEffect(() => {
    if (students.length === 0) {
      fetchStudents()
    }
  }, [students.length, fetchStudents])

  if (loading && students.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!currentStudent && !loading) {
    return (
      <div className="max-w-2xl mx-auto">
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
          Student not found
        </div>
        <Button
          onClick={() => navigate('/manage/students')}
          variant="link"
          className="mt-4 flex items-center gap-2"
        >
          <Icon type="arrow-left" className="w-5 h-5" />
          Back to Students
        </Button>
      </div>
    )
  }

  return (
    <div className="mx-auto space-y-6">
      <div>
        <Button
          onClick={() => navigate('/manage/students')}
          variant="link"
          className="mb-4 flex items-center gap-2"
        >
          <Icon type="arrow-left" className="w-5 h-5" />
          Back to Students
        </Button>
        <h1 className="text-2xl font-bold text-gray-900">
          Edit Student: {currentStudent?.firstName} {currentStudent?.lastName}
        </h1>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <button
              onClick={() => navigate(`/manage/students/${paramId}/general`)}
              className="px-6 py-3 text-sm font-medium border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 transition-colors"
            >
              General
            </button>
            <button
              onClick={() =>
                navigate(`/manage/students/${paramId}/accommodations`)
              }
              className="px-6 py-3 text-sm font-medium border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 transition-colors"
            >
              Accommodations
            </button>
            <button
              onClick={() => navigate(`/manage/students/${paramId}/goals`)}
              className="px-6 py-3 text-sm font-medium border-b-2 border-blue-600 text-blue-600"
            >
              Goals
            </button>
          </nav>
        </div>

        <div className="p-6">
          <StudentGoalsTab studentId={paramId} />
        </div>

        <div className="flex justify-between items-center px-6 py-4 border-t bg-gray-50 rounded-b-lg">
          <div></div>
          <div className="flex gap-3">
            <Button
              onClick={() => navigate(`/manage/students/${paramId}/general`)}
              variant="secondary"
            >
              Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentGoalsPage
